module.exports = __webpack_public_path__ + "img/item11.2380e936.png";